import React from 'react';
import Modal from 'react-bootstrap/Modal';

const formatResultLabel = (result) => {
	if (!result) return '';
	return result
		.toLowerCase()
		.split('_')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};

const resultBadgeClass = (result) => {
	switch (result) {
		case 'PASS':
		case 'APPROVED':
			return 'pass';
		case 'FAIL':
		case 'REJECTED':
			return 'fail';
		case 'HOLD':
		case 'APPROVED_WITH_COMMENTS':
			return 'hold';
		default:
			return '';
	}
};

const InspectionDetailsModal = ({ show, onHide, item }) => {
	const reportTypes = item?.inspectionSummary?.reportTypes || [];

	const handleViewReport = (reportType) => {
		if (reportType.documentUrl) {
			window.open(reportType.documentUrl, '_blank');
			return;
		}
		// A real, synchronous navigation (not an async fetch-then-open) so the browser still
		// treats it as user-initiated and opens it in the foreground. The route itself fetches
		// the report the normal authenticated way (Authorization header), so no token ever
		// appears in the URL.
		window.open(`${window.location.origin}/qc-reports/${reportType.reportId}`, '_blank');
	};

	return (
		<Modal
			show={show}
			animation={true}
			onHide={onHide}
			className="modal-right inspection-details-popup"
			aria-labelledby="inspection-details-modal-title"
		>
			<Modal.Header closeButton>
				<h3 className="semibold-16 mb-0">Inspection Details</h3>
			</Modal.Header>
			<Modal.Body>
				<div className="inspection-details-subject d-flex align-items-center mb-3">
					{item?.productFeatureImageUrl && (
						<img
							src={item.productFeatureImageUrl}
							alt={item?.productReferenceNo}
							className="inspection-details-subject-image mr-2"
						/>
					)}
					<p className="semibold-14 gray_dark_01 mb-0">{item?.productReferenceNo}</p>
				</div>
				<table className="table inspection-status-table">
					<thead>
						<tr>
							<th>Inspection type</th>
							<th>Status</th>
							<th>Result</th>
						</tr>
					</thead>
					<tbody>
						{reportTypes.map((reportType, index) => (
							<tr key={`${reportType.reportType || reportType.label}-${index}`}>
								<td className="regular-12 gray_dark_01">{reportType.label}</td>
								<td>
									{reportType.submitted ? (
										<span
											className="inspection-link regular-12 cursor-pointer"
											onClick={() => handleViewReport(reportType)}
										>
											Submitted
										</span>
									) : (
										<span className="regular-12 gray_dark_03">Not submitted</span>
									)}
								</td>
								<td>
									{reportType.submitted && reportType.result ? (
										<span
											className={`status-badge ${resultBadgeClass(reportType.result)}`}
										>
											{formatResultLabel(reportType.result)}
										</span>
									) : (
										<span className="regular-12 gray_dark_03">—</span>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</Modal.Body>
		</Modal>
	);
};

export default InspectionDetailsModal;
